import { AnimatePresence as Presence , motion as Motion } from 'framer-motion';
import { Routes , Route , useLocation } from 'react-router-dom';
import Home from './Home/Home';
import Order from './Order/Order';
import Inventory from './Inventory/Inventory';

const Routers = () => {

    const Animation = Motion['section'];
    const Location = useLocation();

    return(
        <routers-screen>
            <Presence mode='wait'>
                <Animation key={Location.pathname} initial={ { opacity : 0 } } animate={ { opacity : 1 } } exit={ { opacity : 0 } } transition={ { duration: 0.2, ease: "easeIn" } } className="Animated-Switcher" >
                    <Routes>
                        <Route index element={ <Home /> } />
                        <Route path="/Order/:Table" element={ <Order /> } />
                        <Route path="/Inventory" element={ <Inventory /> } />
                    </Routes>
                </Animation>
            </Presence>
        </routers-screen>
    );

};

export default Routers;